export const dataTableContainerStyles = {
  container: {
    bgcolor: 'background.paper',
    borderRadius: '12px',
    boxShadow: theme =>
      theme.palette.mode === 'dark'
        ? '0 8px 32px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.2)'
        : '0 4px 12px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    p: 2,
    pb: 1,
  },

  headerLeft: {
    flex: 1,
  },

  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },

  title: {
    mb: 2,
    fontWeight: 600,
  },

  filtersContainer: {
    px: 2,
    pb: 2,
  },

  tableWrapper: {
    overflow: 'hidden',
    width: '100%',
    px: 2,
    minHeight: '300px',
    display: 'flex',
    flexDirection: 'column',
    '& .MuiTableContainer-root': {
      boxShadow: 'none',
      border: 'none',
      borderRadius: 0,
      overflow: 'hidden',
      flex: 1, // Take available space
      minHeight: '300px', // Minimum height for table content
    },
    '& .MuiTable-root': {
      width: '100%',
      tableLayout: 'fixed',
    },
  },

  paginationWrapper: {
    minHeight: '72px', // Fixed height for pagination area
    display: 'flex',
    alignItems: 'center',
  },

  addButton: {
    height: '40px',
    px: 3,
    ml: { xs: '-150px', sm: 0 },
  },
};
